"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoRenewalBenefits = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
function AutoRenewalBenefits() {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "media" },
            React.createElement("img", { className: "mr-2 mt-1 margin-top-0", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon" }),
            React.createElement("div", null,
                React.createElement("p", { className: "mb-2" },
                    React.createElement("span", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0" }, "Continuous cover for peace of mind: "),
                    React.createElement("span", { className: "font-weight-light" }, "Save time, stay covered")))),
        React.createElement("div", { className: "media" },
            React.createElement("img", { className: "mr-2 mt-1 margin-top-0", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon" }),
            React.createElement("div", null,
                React.createElement("p", { className: "mb-2" },
                    React.createElement("span", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0" }, "Control: "),
                    React.createElement("span", { className: "font-weight-light" }, "We'll check you're happy with the price and cover 4 weeks before your renewal's due")))),
        React.createElement("div", { className: "media" },
            React.createElement("img", { className: "mr-2 mt-1 margin-top-0", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon" }),
            React.createElement("div", null,
                React.createElement("p", { className: "mb-2" },
                    React.createElement("span", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-16 mb-0" }, "Flexibility: "),
                    React.createElement("span", { className: "font-weight-light" }, "You can opt out of auto-renewal for free at any time"))))));
}
exports.AutoRenewalBenefits = AutoRenewalBenefits;
//# sourceMappingURL=AutoRenewalBenefits.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/AutoRenewalBenefits.js
// module id = 1242
// module chunks = 0